@use "foundation/colors";
@use "foundation/responsive";

.modal-container {
  :global .modal {
    :global .modal-content {
      $max-width: 546px;
      max-width: $max-width;
      overflow-y: hidden;

      @media (max-width: calc(#{$max-width} + 32px)) {
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }

  a {
    color: colors.$primary-eerie-black; /* override link-standalone */
  }

  a span svg {
    width: 180px;
  }
}
